<script>
  import http from '@/service/http'
  import {mapGetters} from 'vuex'
  import moment from 'moment'

  export default {
    name: 'Dashboard',
    data () {
      return {
        osNovo: 0,
        osNovoRevisao: 0,
        osAndamento: 0,
        osAndamentoRevisao: 0,
        tarefasHoje: 0,
        tarefasPendentesHoje: 0,
        tarefasExecucao: 0,
        tarefasAtraso: 0,
        tarefas: [],
        tarefa: {}
      }
    },
    async mounted () {
      if (window.location.hash.indexOf('forbidden=true') > -1) {
        this.$bus.$emit('sweet-erro', {
          message: 'Acesso não permitido'
        })
      }
      await http.get(`/usuarios/check-login`)
      const {data} = await http.get(`/dashboard`)
      if (data != null) {
        this.osNovo = data.osNovo
        this.osAndamento = data.osAndamento
        this.osNovoRevisao = data.osNovoRevisao
        this.osAndamentoRevisao = data.osAndamentoRevisao
        this.tarefasHoje = data.tarefasHoje
        this.tarefasPendentesHoje = data.tarefasPendentesHoje
        this.tarefasExecucao = data.tarefasExecucao
        this.tarefasAtraso = data.tarefasAtraso
        this.tarefas = data.tarefas
      }
      this.$nextTick(() => {
        $('.tooltipped').tooltip({delay: 50})
      })
    },
    methods: {
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
      },
      chipAtraso (data) {
        var vencimento = moment(data).format('YYYY-MM-DD HH:mm')
        var hoje = moment().format('YYYY-MM-DD HH:mm')
        if (hoje > vencimento) {
          return true
        }
      },
      async playTarefa (obj, status) {
        this.$swal({
          title: `Deseja alterar o status da ${obj.tarefa}?`,
          html: 'Esta operação é irreversível',
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero alterar!',
          reverseButtons: true
        }).then(async () => {
          const tarefa = {
            status_id: status
          }
          const {data} = await http.put(`/tarefas/${obj.id}/status`, tarefa)
          obj.status_id = data.tarefa.status_id
          obj.status = data.tarefa.status
        })
      },
      modalTarefa (obj) {
        this.tarefa = obj
        $('#modalTarefa').modal('open')
        this.$nextTick(() => window.Materialize.updateTextFields())
      }
    },
    computed: {
      ...mapGetters(['permissoes']),
      hasTarefas () {
        return this.tarefas.length > 0
      },
      api_url () {
        return process.env.UPLOADS_URL
      }
    }
  }
</script>

<template>
  <div>

    <div class="content">

      <div class="row">

        <div class="col s12 m2 offset-m1" v-show="permissoes.indexOf('contato.visualizar') > -1">
          <router-link :to="{ name: 'contatos.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">contacts</i>
              <br>
              <span>Contatos</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2" v-show="permissoes.indexOf('orcamento.visualizar') > -1">
          <router-link :to="{ name: 'orcamentos.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">assignment_turned_in</i>
              <br>
              <span>Orçamentos</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2" v-show="permissoes.indexOf('os.visualizar') > -1">
          <router-link :to="{ name: 'os.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">build</i>
              <br>
              <span>OS's</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2" v-show="permissoes.indexOf('financeiro-receber.visualizar') > -1">
          <router-link :to="{ name: 'financeiro-receber.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">attach_money</i>
              <br>
              <span>Contas a Receber</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>
        <div class="col s12 m2" v-show="permissoes.indexOf('financeiro-pagar.visualizar') > -1">
          <router-link :to="{ name: 'financeiro-pagar.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">money_off</i>
              <br>
              <span>Contas a Pagar</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2 offset-m1" v-show="permissoes.indexOf('tarefa.visualizar') > -1">
          <router-link :to="{ name: 'cronograma' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">calendar_today</i>
              <br>
              <span>Cronograma</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2" v-show="permissoes.indexOf('tarefa.visualizar') > -1">
          <router-link :to="{ name: 'tarefas.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">check_circle_outline</i>
              <br>
              <span>Tarefas</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'vendas.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">shopping_cart</i>
              <br>
              <span>Vendas</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'compras.index' }" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">add_shopping_cart</i>
              <br>
              <span>Compras</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'relatorios.index'}" class="btn-action green-text text-darken-3">
            <div class="card center-align">
              <br/>
              <i class="material-icons large">insert_chart</i>
              <br>
              <span>Relatórios</span>
              <br/>
              <br/>
            </div>
          </router-link>
        </div>

      </div>

      <!-- Dashboard -->

      <div class="row" v-show="permissoes.indexOf('os.visualizar') > -1">

        <div class="col s12 m2 offset-m2">
          <router-link :to="{ name: 'os.index', params: { status: 1, revisao: 3 } }" class="btn-action green-text text-darken-3">
            <div class="card center-align yellow darken-4 white-text">
              <br />
              <h1 style="margin: 0;">{{ this.osNovo }}</h1>
              <p>
                OS's
                <br />
                aguardando início
              </p>
              <br />
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'os.index', params: { status: 2, revisao: 3 } }" class="btn-action green-text text-darken-3">
            <div class="card center-align green white-text">
              <br />
              <h1 style="margin: 0;">{{ this.osAndamento }}</h1>
              <p>
                OS's
                <br />
                em andamento
              </p>
              <br />
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'os.index', params: { status: 1, revisao: 2 } }" class="btn-action green-text text-darken-3">
            <div class="card center-align yellow darken-4 white-text">
              <br />
              <h1 style="margin: 0;">{{ this.osNovoRevisao }}</h1>
              <p>
                OS's c/revisão
                <br />
                aguardando início
              </p>
              <br />
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'os.index', params: { status: 2, revisao: 2 } }" class="btn-action green-text text-darken-3">
            <div class="card center-align green white-text">
              <br />
              <h1 style="margin: 0;">{{ this.osAndamentoRevisao }}</h1>
              <p>
                OS's c/revisão
                <br />
                em andamento
              </p>
              <br />
            </div>
          </router-link>
        </div>

      </div>

      <div class="row" v-show="permissoes.indexOf('tarefa.visualizar') > -1">

        <div class="col s12 m2 offset-m2">
          <router-link :to="{ name: 'tarefas.index', params: { filtro: 'hoje' } }" class="btn-action green-text text-darken-3">
            <div class="card center-align blue white-text">
              <br />
              <h1 style="margin: 0;">{{ this.tarefasHoje }}</h1>
              <p>
                Tarefas
                <br />
                para hoje
              </p>
              <br />
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'tarefas.index', params: { filtro: 'pendentes' } }" class="btn-action green-text text-darken-3">
            <div class="card center-align yellow darken-4 white-text">
              <br />
              <h1 style="margin: 0;">{{ this.tarefasPendentesHoje }}</h1>
              <p>
                Tarefas
                <br />
                pendentes para hoje
              </p>
              <br />
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'tarefas.index', params: { filtro: 'execucao' } }" class="btn-action green-text text-darken-3">
            <div class="card center-align green white-text">
              <br />
              <h1 style="margin: 0;">{{ this.tarefasExecucao }}</h1>
              <p>
                Tarefas
                <br />
                em execução
              </p>
              <br />
            </div>
          </router-link>
        </div>

        <div class="col s12 m2">
          <router-link :to="{ name: 'tarefas.index', params: { filtro: 'atraso' } }" class="btn-action green-text text-darken-3">
            <div class="card center-align red white-text">
              <br />
              <h1 style="margin: 0;">{{ this.tarefasAtraso }}</h1>
              <p>
                Tarefas
                <br />
                em atraso
              </p>
              <br />
            </div>
          </router-link>
        </div>

      </div>

      <div class="row z-depth-1" v-show="hasTarefas">
        <div class="col s12">
          <table class="responsive-table bordered highlight">
            <thead>
            <tr>
              <th>#</th>
              <th>Tarefa</th>
              <th>Solicitante</th>
              <th># OS</th>
              <th>Prazo</th>
              <th>Status</th>
              <th></th>
              <th class="right-align">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="tarefa in tarefas">
              <td>
                <router-link :to="{ name: 'tarefas.form', params: { id: tarefa.id } }">
                  {{ tarefa.id }}
                </router-link>
              </td>
              <td>{{ tarefa.tarefa }}</td>
              <td>{{ (tarefa.usuario) ? tarefa.usuario.nome_completo : '-' }}</td>
              <td>
                <router-link :to="{ name: 'os.form', params: { id: tarefa.os_id } }" v-if="tarefa.os">
                  {{ tarefa.os_id }}
                </router-link>
                <span v-else>-</span>
              </td>
              <td>{{ formatDate(tarefa.prazo) }}</td>
              <td>{{ tarefa.status.status }}</td>
              <td class="right-align">
                <span class="new badge green" v-if="tarefa.status_id === 3" data-badge-caption="concluída"></span>
                <span class="new badge red" v-if="tarefa.status_id < 3 && chipAtraso(tarefa.prazo) === true" data-badge-caption="atrasada"></span>
              </td>
              <td class="right-align">
                <a href="#" class="tooltipped" :data-label="tarefa.tarefa" data-position="left" data-delay="50" data-tooltip="Detalhes" @click.prevent="modalTarefa(tarefa)"><i class="material-icons blue-text">search</i></a>
                <a href="#" class="tooltipped" :data-label="tarefa.tarefa" data-position="left" data-delay="50" data-tooltip="Iniciar Tarefa" v-show="tarefa.status_id === 1" @click.prevent="playTarefa(tarefa, 2)"><i class="material-icons blue-text">play_circle_filled</i></a>
                <a href="#" class="tooltipped" :data-label="tarefa.tarefa" data-position="left" data-delay="50" data-tooltip="Finalizar Tarefa" v-show="tarefa.status_id === 2" @click.prevent="playTarefa(tarefa, 3)"><i class="material-icons green-text">play_circle_filled</i></a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <div id="modalTarefa" class="modal">
      <div class="modal-content">
        <h4>{{ tarefa.tarefa }}</h4>
        <div class="pre-formatted">{{ tarefa.descricao }}</div>
        <hr />
        
        <div class="row" v-if="tarefa.orcamento">
          <div class="col s12">
            Endereço: <strong>{{ tarefa.orcamento.logradouro }}, {{ tarefa.orcamento.numero }} {{ tarefa.orcamento.complemento }} - {{ tarefa.orcamento.bairro }} - {{ tarefa.orcamento.cidade }} / {{ tarefa.orcamento.estado }} - CEP: {{ tarefa.orcamento.cep }}</strong>
          </div>
        </div>
        <div class="row" v-if="tarefa.orcamento && tarefa.orcamento.fotos">
          <div class="col s12 m6" v-for="foto in tarefa.orcamento.fotos" :key="foto.id">
            <img :src="`${api_url}/orcamentos/${foto.foto}`" style="max-width: 90%; height: 150px;" class="pointer center-align">
            <br /><br />
          </div>
        </div>
        <div class="row">
          <div class="col s12 m6 center-align" v-for="(anexo, indexAnexo) in tarefa.anexos">
            <div class="row">
              <div class="col s12 m2">
                <br>
                <a :href="`${api_url}/tarefa/${anexo.anexo}`" target="_blank"><i class="material-icons">file_download</i></a>
              </div>
              <div class="input-field col s12 m10">
                <input name="legenda" :id="`legenda-${indexAnexo}`" disabled type="text"
                       v-model="anexo.legenda"/>
                <label :for="`legenda-${indexAnexo}`">Legenda</label>
              </div>
            </div>
            <br clear="all"/>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/dashboard/index.vue